import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Button from '../../../common/button/Button';
import Slider from '../../../common/Slider/Slider';

const artistsUrl = '/artistas/';
const imgUrl = 'https://a1media.antena1.com.br/image/artista/482x250/';
const defaultImage = 'defaultArtista.jpg';

// const AtoZWords = ['N°', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

const SearchArtistsComponent = ({ dataArtists, device }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [results, setResults] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [suggestive, setSuggestive] = useState(false);
    const [dataArtistsJS, setDataArtistsJS] = useState([]);
    // const [selectedAtoZ, setSelectedAtoZ] = useState(false);

    function _isNumber(value) {
        return typeof value === 'number' && !Number.isNaN(value);
    }

    function _filterTermInDataArtists(searchTermSup, searchTermPosition = false) {
        const searchTermLow = searchTermSup.toLowerCase();

        if (searchTermPosition !== false && _isNumber(searchTermPosition)) {
            return dataArtistsJS.filter((el) => (_isNumber(searchTermSup) || searchTermSup === 'N°'
                ? _isNumber(Number(el.Nam.trim()[searchTermPosition]))
                : el.Nam.trim()[searchTermPosition].toLowerCase().indexOf(searchTermLow) !== -1));
        }

        return dataArtistsJS.filter((el) => el.Nam.trim().toLowerCase().indexOf(searchTermLow) !== -1);
    }

    // function _filterArtistsByLetter(letter) {
    //     if (letter === 'N°' || _isNumber(letter)) {
    //         const filteredArtists = dataArtistsJS.filter((el) => {
    //             const artistName = el.Nam.trim();
    //             const firstChar = artistName.charAt(0);

    //             const startsWithLetter = AtoZWords.some((char) => firstChar.toUpperCase() === char);

    //             return !startsWithLetter;
    //         });

    //         return filteredArtists;
    //     }

    //     const selectedLetter = letter.toUpperCase();

    //     const filteredArtists = dataArtistsJS.filter((el) => {
    //         const artistName = el.Nam.trim();

    //         return artistName.charAt(0).toUpperCase() === selectedLetter;
    //     });

    //     return filteredArtists;
    // }

    // function _handleAtoZ(event) {
    //     const character = event.target.value;
    //     const filterArtists = _filterArtistsByLetter(character);

    //     setSelectedAtoZ(character);

    //     setSearchTerm('');

    //     if (filterArtists.length > 0) {
    //         setResults(filterArtists);

    //         setSuggestive(false);

    //         setNotFound(false);
    //     } else if (filterArtists.length === 0) {
    //         setResults(false);

    //         setNotFound(true);
    //     }
    // }

    function clearSuggestionsTimeout() {
        setTimeout(() => {
            setSuggestive(false);
        }, 400);
    }

    function _hideSuggestions() {
        clearSuggestionsTimeout();
    }

    function _search(event) {
        event.preventDefault();

        const searchTermSup = searchTerm;
        const filterArtists = _filterTermInDataArtists(searchTermSup);

        if (filterArtists.length > 0) {
            setResults(filterArtists);

            setSuggestive(false);

            setNotFound(false);
        } else if (filterArtists.length === 0) {
            setNotFound(true);

            setResults(false);
        }
    }

    function _suggestiveSearch() {
        const searchterm = searchTerm;
        const filterArtists = _filterTermInDataArtists(searchterm);

        if (filterArtists.length > 0) {
            setSuggestive(filterArtists);
        } else if (filterArtists.length === 0) {
            setSuggestive(false);
        }
    }

    function _handleSubmit(event) {
        _search(event);
    }

    function _handleInputChange(event) {
        setSearchTerm(event.target.value);

        const searchTermSup = event.target.value;

        if (searchTermSup.length > 0) {
            _suggestiveSearch();
        } else {
            setSuggestive(false);
        }
    }


    useEffect(() => {
        if (dataArtists) {
            setDataArtistsJS(dataArtists);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // This avoid a memory leak caused by the _hideSuggestions function
    useEffect(() => () => clearTimeout(clearSuggestionsTimeout), []);

    const numResults = results.length;
    const breakpoints = {
        576: {
            slidesPerView: numResults >= 3 ? 3 : numResults,
        },
        974: {
            slidesPerView: numResults >= 4 ? 4 : numResults,
        },
    };

    return (
        <div>
            <form className="d-flex form-search" onSubmit={_handleSubmit}>
                <div className="searchField tw-relative">
                    <input
                        onBlur={_hideSuggestions}
                        value={searchTerm}
                        onChange={() => { _handleInputChange }}
                        className="form-control"
                        placeholder="Pesquisar"
                        type="text"
                        onInput={_handleInputChange}
                    />
                    <FontAwesomeIcon className="search-icon" icon={faSearch} width="40px" />
                    {Array.isArray(suggestive) && suggestive.length > 0 && (
                        <ul className="list-group tw-m-auto tw-w-full md:tw-w-1/3 lg:tw-w-72 tw-absolute tw-z-20 tw-mt-12">
                            {suggestive.map(({ Id, Url, Nam }) => (
                                <li key={Id} className="tw-w-full">
                                    <Button className="list-group-item tw-w-full" to={artistsUrl + Url} title={Nam}>
                                        {Nam}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </form>
            <ul className="results">
                {
                    results &&
                    <Slider
                        breakpoints={breakpoints}
                        containerClass="swiper-container searchArtist-swiper-container"
                        navigation={device === 'desktop'}
                        autoplay={{ delay: 1000 }}
                    >
                        {
                            results.map((item) => {
                                if (item.Img == null) {
                                    return (
                                        <div key={item.Id}>
                                            <Button title={`Biografia de ${item.Nam}`} to={artistsUrl + item.Url}>
                                                <img src={imgUrl + defaultImage} alt={`A1 Default Album para ${item.Nam}`} loading="lazy" />
                                                <h4>
                                                    {item.Nam}
                                                </h4>
                                            </Button>
                                        </div>
                                    );
                                }

                                return (
                                    <div key={item.Id}>
                                        <Button title={`Biografia de ${item.Nam}`} to={artistsUrl + item.Url}>
                                            <img alt={`Capa - ${item.Nam}`} src={imgUrl + item.Img} loading="lazy" />
                                            <h4>
                                                {item.Nam}
                                            </h4>
                                        </Button>
                                    </div>
                                );
                            })
                        }
                    </Slider>
                }
                {
                    notFound &&
                    <div className="notice">
                        <h3>Não foi possível encontrar esse artista</h3>
                        <h4>Verifique se o nome está escrito corretamente ou procure por outro.</h4>
                    </div>
                }
            </ul>
        </div>
    );
};

SearchArtistsComponent.propTypes = exact({
    dataArtists: PropTypes.arrayOf(PropTypes.object).isRequired,
    device: PropTypes.string,
});

export default SearchArtistsComponent;
